import { useTranslation } from 'react-i18next';
import { Link } from 'wouter';
import { ArrowUp, Globe, DollarSign, RefreshCw, Shield, Zap, ArrowRight } from 'lucide-react';

const benefits = [
  {
    id: 'scalability',
    title: 'benefitsCloud.benefits.0.title',
    description: 'benefitsCloud.benefits.0.description',
    icon: <ArrowUp className="w-6 h-6" />,
  },
  {
    id: 'accessibility',
    title: 'benefitsCloud.benefits.1.title',
    description: 'benefitsCloud.benefits.1.description',
    icon: <Globe className="w-6 h-6" />,
  },
  {
    id: 'cost-effective',
    title: 'benefitsCloud.benefits.2.title',
    description: 'benefitsCloud.benefits.2.description',
    icon: <DollarSign className="w-6 h-6" />,
  },
  {
    id: 'automatic-updates',
    title: 'benefitsCloud.benefits.3.title',
    description: 'benefitsCloud.benefits.3.description',
    icon: <RefreshCw className="w-6 h-6" />,
  },
  {
    id: 'security',
    title: 'benefitsCloud.benefits.4.title',
    description: 'benefitsCloud.benefits.4.description',
    icon: <Shield className="w-6 h-6" />,
  },
  {
    id: 'performance',
    title: 'benefitsCloud.benefits.5.title',
    description: 'benefitsCloud.benefits.5.description',
    icon: <Zap className="w-6 h-6" />,
  },
];

export function BenefitsCloud() {
  const { t } = useTranslation();

  return (
    <section id="benefits" className="bg-white dark:bg-slate-900 py-16 sm:py-20 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-12 lg:mb-16">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white sm:text-4xl">
            {t('benefitsCloud.title')}
          </h2>
          <p className="mt-4 text-lg text-gray-600 dark:text-gray-300">
            {t('benefitsCloud.description')}
          </p>
        </div>

        <div className="mt-12">
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8">
            {benefits.map((benefit, index) => (
              <div 
                key={index} 
                className="group relative bg-white dark:bg-slate-800 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 ease-in-out overflow-hidden border border-gray-100 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 hover:-translate-y-1 h-full flex flex-col"
              >
                <div className="p-6 sm:p-8 flex-1 flex flex-col">
                  <div className="flex items-start space-x-4 mb-6">
                    <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center rounded-lg bg-[#002549] text-white transition-colors duration-300">
                      {benefit.icon}
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 dark:text-white pt-2">
                      {t(benefit.title)}
                    </h3>
                  </div>
                  <div className="flex-1">
                    <p className="text-gray-600 dark:text-gray-300 leading-relaxed line-clamp-4">
                      {t(benefit.description)}
                    </p>
                  </div>
                  <div className="mt-6 pt-4 border-t border-gray-100 dark:border-slate-700">
                    <Link 
                      href={`/benefits/${benefit.id}`}
                      className="inline-flex items-center text-primary-700 dark:text-primary-300 font-medium hover:underline hover:text-primary-900 dark:hover:text-primary-100 transition-colors duration-200 mt-2 group text-sm"
                    >
                      {t('common.learnMore')}
                      <ArrowRight className="ml-1 h-4 w-4 group-hover:translate-x-1 transition-transform duration-200" />
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
